import React, { useState, ChangeEvent, Fragment } from "react";
import {
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogActions,
  Button,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  ListItemIcon,
} from "@material-ui/core";
import {
  Archive as ArchiveIcon,
  HourglassEmpty as WaitingIcon,
  Cancel as CancelIcon,
} from "@material-ui/icons";
import LoadingButton from '../Shared/LoadingButton';
import { RootState } from "../../reducers";
import { useDispatch, useSelector } from "react-redux";
import { thunkArchiveTorrents } from "../../thunks";
import { size } from "../util";
import FolderField from '../Shared/FolderField';
import { setSelectedTorrents } from "../../actions";


export default function Archive() {
  const {
    archive: { pending, queue },
    torrent: { selected },
    setting: { archiveFolder }
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [currentArchiveFolder, setCurrentArchiveFolder] = useState("");
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const submitable = selected.length > 0 && currentArchiveFolder;

  const handleOpen = () => {
    setCurrentArchiveFolder(currentArchiveFolder || archiveFolder);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleArchiveFolderChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentArchiveFolder(e.target.value);
  };

  const handleSubmit = () => {
    dispatch(thunkArchiveTorrents(selected, currentArchiveFolder));
    setOpen(false);
    dispatch(setSelectedTorrents([]));
  };

  const confirmMsg = useSelector((state: RootState) => {
    const { selected, list } = state.torrent;
    for (const id of selected) {
      const torrent = list.find(t => t.id === id);
      if (!torrent) {
        continue
      }
      if (torrent.progress === undefined) {
        return 'Found unarchivable torrent in selected list, are you sure to proceed?'
      }
      if (torrent.progress < 1) {
        return 'Found incomplete torrent in selected list, are you sure to proceed?'
      }
    }
  })

  const handleClosePopover = () => setAnchorEl(null);

  return (
    <span>
      <span
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
        onMouseLeave={(e) => setAnchorEl(null)}
      >
        <LoadingButton
          pending={pending}
          color="inherit"
          onClick={handleOpen}
          confirm={confirmMsg}
        >
          <Badge badgeContent={queue.length} color="secondary">
            <ArchiveIcon />
          </Badge>
        </LoadingButton>
        <Popover
          id="mouse-over-popover"
          open={!!anchorEl && queue.length > 0}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={() => setAnchorEl(null)}
          disableRestoreFocus
        >
          <LoadingButton
            pending={pending}
            color="inherit"
            onClick={handleOpen}
            confirm={confirmMsg}
          >
            <ArchiveIcon />
          </LoadingButton>
          <IconButton style={{ float: "right" }} onClick={handleClosePopover}>
            <CancelIcon />
          </IconButton>
          <List component="nav">
            {queue.map((item) => (
              <ListItem key={item.id}>
                <ListItemIcon>
                  <Fragment>
                    {!!item.isCurrent && <CircularProgress />}
                    {!item.isCurrent && <WaitingIcon />}
                  </Fragment>
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  secondary={`${item.name} (${size(item.size)})`}
                />
              </ListItem>
            ))}
          </List>
        </Popover>
      </span>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle>Archive Torrents</DialogTitle>
        <DialogContent dividers style={{ width: "600px" }}>
          <Grid container spacing={3}>
            <Grid item xs={3} className="form-row-label">
              Archive to:
            </Grid>
            <Grid item xs={9} className="form-row-label">
              <FolderField
                value={currentArchiveFolder}
                onChange={handleArchiveFolderChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleSubmit}
            disabled={!submitable}
            color="primary"
          >
            Ok
          </Button>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </span>
  );
}